var React = require('react');

function Verified (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"M6.603 2.299A4.49 4.49 0 0 1 10 .75c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.49 4.49 0 0 1 1.307 3.497A4.49 4.49 0 0 1 19.75 10.5a4.49 4.49 0 0 1-1.549 3.397 4.49 4.49 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 10 20.25a4.49 4.49 0 0 1-3.397-1.549 4.491 4.491 0 0 1-3.498-1.306 4.49 4.49 0 0 1-1.307-3.498A4.49 4.49 0 0 1 .25 10.5c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L7.53 10.72a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094z","fill":"#e5624f","fillRule":"evenodd"}));
}

Verified.defaultProps = {"fill":"none","height":"21","width":"20"};

module.exports = Verified;

Verified.default = Verified;
